import { request } from "./index";
import Filter from "@/store/filter";
import { sortData, hasKey, updatedField, getCountriesMapping, EVENTS } from "@/utils";
import { country_amz_sp_api_marketplace_ids, country_code_amz_sp_api_marketplace_ids, country_codes_flipped, country_codes } from "@/utils/countries";
import ContentDisplayRulesMixin from "@/mixins/ContentDisplayRulesMixin.vue";
import _ from "lodash";
import { reactive } from "vue";
const content = {
  state: {
    list: [],
    existing_all_market_place_list: [],
    item: {},
    modified_list: [],
    keyword_list: [],
    push_status_selected: new Set(),
    images: [],
    selected_contents: [],
    current_mode: "default",
    pushModal: false,
    sellers_filter: new Filter([], [], "id"),
    marketplaces_filter: new Filter([], [], "id"),
    products_filter: new Filter([], [], "id"),
    segments_filter: new Filter([], [], "segments"),
    sellers: {
      list: [],
      selected: [],
      modified_list: [],
      modified_selected: []
    },
    country: {
      list: [],
      selected: [],
      modified_list: [],
      modified_selected: []
    },
    contentSuggestion: {
      list: [],
      selected: [],
      modified_list: [],
      modified_selected: []
    },
    total_count: 0,
    total_count_for_parent_view: 0,
    page: 1,
    perPage: 20,
    parent_asin_to_child_asin_map: new Map(),
    parent_asin_string_to_asin_array: new Map(),
    all_child_content_ids: [],
    all_parent_marketplaces: [],
    solo_items: [],
    is_copying: false
  },
  getters: {
    contentKeyWordsGet(state) {
      return () => {
        return state.keyword_list;
      };
    },
    contentSoloItemsGet(state) {
      return () => {
        return state.solo_items;
      };
    },
    contentGetByPushStatus(state) {
      return push_status => {
        return state.modified_list.filter(item => item.push_status == push_status);
      };
    },
    getCountry() {
      return marketplace_id => {
        for (const key in country_amz_sp_api_marketplace_ids) {
          if (marketplace_id == country_amz_sp_api_marketplace_ids[key]) {
            return key;
          }
        }
        return null;
      };
    },
    getCountryCode() {
      return country => {
        if (hasKey(country_codes, country)) {
          //console.log(`The key '${country_code}' exists.`);
          return country_codes[country];
        }
        return null;
      };
    },
    getMarketPlaceIdByCountryCode() {
      return country_code => {
        if (hasKey(country_code_amz_sp_api_marketplace_ids, country_code)) {
          //console.log(`The key '${country_code}' exists.`);
          return country_code_amz_sp_api_marketplace_ids[country_code];
        }
        return null;
      };
    },
    getCountryFlag() {
      return (country_code, type = "shiny") => {
        country_code = country_code === "UK" ? "GB" : country_code;
        if (country_code) {
          //return `https://flagsapi.com/${country_code}/${type}/64.png`;
          return `/assets/flags/${country_code}.png`;
        }
        return null;
      };
    },
    getItemFromExistingMarketPlaceList(state) {
      return params => {
        const item = state.existing_all_market_place_list.find(el => el.marketplace_id == params.marketplace_id);
        return item ? item : null;
      };
    },
    contentItem(state) {
      return params => {
        const item = state.list.find(el => el.content_id == params.content_id) || state.solo_items.find(el => el.content_id == params.content_id);
        return item ? item : null;
      };
    },
    contentSellersListGet(state) {
      return () => {
        return state.sellers_filter.filterValues;
      };
    },
    modifiedContentSellersListGet(state) {
      return () => {
        return state.sellers.modified_list;
      };
    },
    modifiedContentSellersSelectedGet(state) {
      return () => {
        return state.sellers.modified_selected;
      };
    },
    modifiedContentCountriesListGet(state) {
      return () => {
        return state.country.modified_list;
      };
    },
    modifiedContentCountriesSelectedGet(state) {
      return () => {
        return state.marketplaces_filter.filterValues;
      };
    },
    modifiedContentSuggestionsListGet(state) {
      return () => {
        return state.contentSuggestion.modified_list;
      };
    },
    modifiedContentSuggestionsSelectedGet(state) {
      return () => {
        return state.contentSuggestion.modified_selected;
      };
    },
    contentCountriesListGet(state) {
      return () => {
        return state.country.list;
      };
    },
    contentCountriesSelectedGet(state) {
      return () => {
        return state.marketplaces_filter.filterValues;
      };
    },
    contentSuggestionsListGet(state) {
      return () => {
        return state.products_filter.filterValues;
      };
    },
    contentSuggestionsSelectedGet(state) {
      return () => {
        return state.products_filter.selectedItems;
      };
    },
    totalCountGet(state) {
      return () => {
        return state.total_count;
      };
    },
    totalCountForParentViewGet(state) {
      return () => {
        return state.total_count_for_parent_view;
      };
    },
    totalModifiedCountGet(state) {
      return () => {
        return state.total_modified_count;
      };
    },
    modifiedContentUpdatedSellersGet: (_, getters) => () => {
      const sellers = getters.modifiedContentSellersSelectedGet().length ? getters.modifiedContentSellersSelectedGet() : getters.modifiedContentSellersListGet();
      return sellers.map(seller => seller.id);
    },
    contentUpdatedSellersGet: state => () => {
      return state.sellers_filter.filterValues;
    },
    contentChildrenSelectedGet(state, getters) {
      return () => {
        return {
          seller_list: getters.contentUpdatedSellersGet(),
          marketplace_list: getters.contentCountriesSelectedGet(),
          ...getters.contentGetAllChildContentIds()
        };
      };
    },
    contentSelectedItemGet(state, getters) {
      return () => {
        return getters.contentSuggestionsSelectedGet().filter(item => item.asin && item.sku).map(item => ({
          asin: item.asin,
          sku: item.sku
        }));
      };
    },
    contentFiltersSelectedGet(state, getters) {
      return () => {
        return {
          seller_list: getters.contentUpdatedSellersGet(),
          marketplace_list: getters.contentCountriesSelectedGet(),
          asin_list: getters.contentSuggestionsSelectedGet().map(item => item.asin).filter(element => !!element),
          sku_list: getters.contentSuggestionsSelectedGet().map(item => item.sku).filter(element => !!element),
          product_list: [],
          keyword_list: getters.contentKeyWordsGet().filter(element => !!element),
          content_id_list: getters.contentSuggestionsSelectedGet().map(item => {
            return {
              sku: item.sku,
              asin: item.asin
            };
          }).filter(element => !!element)
        };
      };
    },
    // Segment-aware filters for the content BigQuery call. Leaves the base
    // `contentFiltersSelectedGet` untouched and only falls back to the selected
    // segments' asin/sku lists when no products are explicitly selected
    // (same pattern as ProductData / cogs `productCogsDataGetGcpFilters`).
    contentSegmentsSelectedGet(state) {
      return () => state.segments_filter.selected;
    },
    contentGetGcpFilters(state, getters) {
      return () => {
        const base = getters.contentFiltersSelectedGet();
        const products = getters.contentSuggestionsSelectedGet();
        const segments = getters.contentSegmentsSelectedGet();
        if (products.length || !segments.length) {
          return base;
        }
        return {
          ...base,
          asin_list: Filter.flatten("asin_list", segments),
          sku_list: Filter.flatten("sku_list", segments)
        };
      };
    },
    contentFiltersSuggestionsGet(state, getters) {
      return () => {
        return {
          seller_list: getters.contentUpdatedSellersGet(),
          marketplace_list: getters.contentCountriesSelectedGet(),
          asin_list: [],
          sku_list: [],
          product_list: [],
          keyword_list: getters.contentKeyWordsGet().filter(element => !!element)
        };
      };
    },
    modifiedContentsSelectedGet(state, getters) {
      return () => {
        let modified_list_by_push_status = state.modified_list.filter(item => state.push_status_selected.has(item.push_status));
        let modified_list_to_use = modified_list_by_push_status.length > 0 ? modified_list_by_push_status : state.modified_list;
        let specific_content = modified_list_to_use.filter(item => getters.contentUpdatedSellersGet().some(seller => seller.seller_id == item.seller_id) && getters.contentCountriesSelectedGet().some(country_marketplace_id => country_marketplace_id == item.marketplace_id) && getters.contentSuggestionsSelectedGet().some(suggestion => suggestion.asin == item.asin) || getters.contentSuggestionsSelectedGet().some(suggestion => suggestion.sku == item.sku));
        return specific_content.length > 0 ? specific_content : modified_list_to_use;
      };
    },
    contentGetAllChildContentIds(state) {
      return () => ({
        content_id_list: state.all_child_content_ids
      });
    }
    //To be deleted soon; this idea has been abandoned
    // modifiedContentFiltersSelectedGet(state, getters) {
    //   return () => {
    //     return {
    //       seller_list: getters.modifiedContentUpdatedSellersGet(),

    //       marketplace_list: getters
    //         .modifiedContentCountriesSelectedGet()
    //         .map((country) => country.code)
    //         .map((countryCode) =>
    //           getters.getMarketPlaceIdByCountryCode(countryCode)
    //         ),

    //       asin_list: getters
    //         .modifiedContentSuggestionsSelectedGet()
    //         .map((item) => item.asin),

    //       sku_list: getters
    //         .modifiedContentSuggestionsSelectedGet()
    //         .map((item) => item.sku),

    //       product_list: getters
    //         .modifiedContentSuggestionsSelectedGet()
    //         .map((item) => item.product_name),
    //     };
    //   };
    // },
  },
  mutations: {
    isCopyingSet(state, payload) {
      state.is_copying = payload;
    },
    contentsSellersFilterSet(state, payload) {
      state.sellers_filter.restore(payload);
    },
    contentsMarketplacesFilterSet(state, payload) {
      state.marketplaces_filter.restore(payload);
    },
    contentsListSet(state, payload) {
      state.list = payload;
    },
    contentSelectedContentsSet(state, payload) {
      state.selected_contents = payload;
    },
    contentCurrentModeSet(state, payload) {
      state.current_mode = payload;
    },
    contentPushModalStatusSet(state, payload) {
      state.pushModal = payload;
    },
    contentExistingMarketPlaceListSet(state, payload) {
      state.existing_all_market_place_list = payload;
    },
    contentModifiedSellersListSet(state, payload) {
      state.sellers.modified_list = payload;
    },
    contentModifiedCountriesListSet(state, payload) {
      state.country.modified_list = payload;
    },
    contentModifiedListSet(state, payload) {
      state.modified_list = payload;
    },
    contentUpdateModifiedListSet(state, payload) {
      state.modified_list = state.modified_list.filter(item => payload.some(content => content.sku == item.sku && content.asin == item.asin && content.seller_id == item.seller_id && content.marketplace_id == item.marketplace_id));
    },
    contentDraftListSet(state, payload) {
      state.draft_list = payload;
    },
    contentSyncErrorListSet(state, payload) {
      state.sync_error_list = payload;
    },
    contentPushStatusSelectedReset(state) {
      state.push_status_selected.clear();
    },
    contentPushStatusSelectedUpdate(state, payload) {
      if (!state.push_status_selected.has(payload)) {
        state.push_status_selected.add(payload);
      } else {
        state.push_status_selected.delete(payload);
      }
      if (state.push_status_selected.size) {
        state.current_mode = "push_status_mode";
      } else {
        state.current_mode = "default";
      }
    },
    contentPageSet(state, payload) {
      state.page = payload;
    },
    contentPerPageSet(state, payload) {
      state.perPage = payload;
    },
    contentModifiedSuggestionsListSet(state, payload) {
      state.contentSuggestion.modified_list = payload;
    },
    contentModifiedSellersSelectedSet(state, payload) {
      state.sellers.modified_selected = payload;
    },
    contentModifiedCountriesSelectedSet(state, payload) {
      state.country.modified_selected = payload;
    },
    contentModifiedContentsSelectedSet(state, payload) {
      state.contentSuggestion.modified_selected = payload;
    },
    contentFieldSet(state, payload) {
      //console.log("contentFieldSet", payload);
      const applyUpdater = item => {
        if (item.asin == payload.asin && item.content_id === payload.content_id) {
          if (payload.type == "image") {
            item.image_small = payload.value;
            item.image_medium = payload.value;
            item.image_large = payload.value;
          } else {
            item.omny_version[payload.type] = payload.value;
            item.modified_attributes ??= [];
            item.prev_push_status ??= item.push_status;
            const bullet_point_attributes = ["bullet_point_1", "bullet_point_2", "bullet_point_3", "bullet_point_4", "bullet_point_5"];
            let attribute_to_push = bullet_point_attributes.includes(payload.type) ? "bullet_point" : payload.type;
            if (ContentDisplayRulesMixin.methods.isOmnyVersionSameAsAmazonWithCaseSensitive(item, payload.type) || ContentDisplayRulesMixin.methods.isOmnyVersionEmptyString(item, payload.type)) {
              item.modified_attributes = item.modified_attributes.filter(attr => attr !== attribute_to_push);
              const uiPushStatus = ["accepted", "not_accepted", "seller_central_not_accepted"];
              item.push_status = item.modified_attributes?.length == 0 && (item.push_status == "draft" || uiPushStatus.includes(item.push_status)) ? item.prev_push_status : item.push_status;
            } else {
              item = ContentDisplayRulesMixin.methods.updateModifiedAttributes(item, attribute_to_push);
            }
          }
        }
        return item;
      };
      state.list = state.list.map(applyUpdater);
      state.solo_items = state.solo_items.map(applyUpdater);
    },
    contentSmartListingFieldSet(state, payload) {
      state.list = state.list.map(item => {
        if (item.asin == payload.asin && item.content_id === payload.content_id) {
          item.smart_listing_data ??= {};
          item.smart_listing_data[payload.type] = payload.value;
        }
        return item;
      });
    },
    contentUpdateAfterPush(state, payload) {
      state.list = state.list.map(item => {
        let accumulated_item = item;
        if (item.asin == payload.asin && item.content_id === payload.content_id) {
          //destructing assignment
          accumulated_item = {
            ...item,
            ...payload
          };
        }
        return accumulated_item;
      });
    },
    imageListSet(state, payload) {
      state.images = payload;
    },
    contentSellersListSet(state, payload) {
      state.sellers.list = payload;
    },
    contentSellersSelectedSet(state, payload) {
      state.sellers.selected = payload;
    },
    contentCountriesListSet(state, payload) {
      state.country.list = sortData(payload);
    },
    contentCountriesSelectedSet(state, payload) {
      state.country.selected = sortData(payload);
    },
    contentSuggestionsListSet(state, payload) {
      state.contentSuggestion.list = sortData(payload, "product_name");
    },
    contentSuggestionsSelectedSet(state, payload) {
      state.contentSuggestion.selected = sortData(payload, "product_name");
    },
    contentTotalCountSet(state, payload) {
      let total_count = payload[0]?.total_count ?? 0;
      state.total_count = total_count;
    },
    contentTotalCountForParentViewSet(state, payload) {
      let total_count = payload[0]?.total_count ?? 0;
      state.total_count_for_parent_view = total_count;
    },
    totalModifiedCountSet(state, payload) {
      state.total_modified_count = payload.length;
    },
    contentsKeyWordListSet(state, payload) {
      state.keyword_list = payload;
    },
    contentsModifiedListSet(state, payload) {
      state.modified_list = payload;
    },
    contentParentsMapSet(state, payload) {
      /*
        [
          {[k]: v, child_asin_list: []}
        ] -> Map([])
      */
      state.parent_asin_to_child_asin_map = payload;
    },
    contentSetAllChildContentIds(state, payload) {
      state.all_child_content_ids = payload;
    },
    contentSetParentMarketplaces(state, payload) {
      state.all_parent_marketplaces = payload;
    },
    contentParentsStringMapSet(state, payload) {
      state.parent_asin_string_to_asin_array = payload;
    },
    contentSoloItemsSet(state, payload) {
      state.solo_items = payload;
    }
  },
  actions: {
    async contentModifiedList({
      commit
    }, payload) {
      commit("contentModifiedSellersListSet", []);
      commit("contentModifiedCountriesListSet", []);
      commit("contentModifiedSuggestionsListSet", []);
      commit("totalModifiedCountSet", []);
      let result = (await request("/content/getmodifiedcontentlist", "POST", payload)) ?? {
        data: [],
        suggesticontentListons: []
      };
      if (result) {
        commit("contentModifiedListSet", result.data);
        //   commit("contentModifiedCountriesListSet", data);
        //   commit("contentModifiedSuggestionsListSet", data);
        //   commit("totalModifiedCountSet", data);
      }
      return result;
    },
    contentSetSelectedPushStatusList({
      commit
    }, payload) {
      commit("contentPushStatusSelectedListSet", payload);
    },
    async contentGetCountries({
      commit,
      getters
    }) {
      try {
        const payload = {
          seller_list: getters.contentUpdatedSellersGet()
        };
        if (!Array.isArray(payload.seller_list) || payload.seller_list.length === 0) {
          throw new Error("Seller ID must be a non-empty array");
        }
        const result = (await request("/content/getcountries", "POST", payload)) ?? {
          data: []
        };
        if (result.data) {
          let localCountriesMapping = await getCountriesMapping();
          let filteredCountries = localCountriesMapping.filter(localCountriesMapping => result.data.some(data => data.country_code === localCountriesMapping.code));
          commit("contentCountriesListSet", filteredCountries);
        }
        return result.data;
      } catch (error) {
        //console.log("Error: ", error);
        throw new Error(error);
      }
    },
    async contentGetStatus({
      commit
    }, payload) {
      try {
        //console.log("payload: ", payload);
        let result = (await request("/content/getstatus", "POST", payload)) ?? {
          data: []
        };
        //console.log("result: ", result);
        return result.data;
      } catch (error) {
        //console.log("Error: ", error);
        throw new Error(error);
      }
    },
    async contentGetByFilters({
      commit
    }, payload) {
      let result = (await request("/content/getcontentlist", "POST", payload)) ?? {
        data: [],
        suggestions: []
      };
      return result;
    },
    async contentGetByContentId({
      commit
    }, payload) {
      let result = (await request("/content/getcontentlistbyid", "POST", payload)) ?? {
        data: [],
        suggestions: []
      };
      if (result?.data) {
        return result;
      }
      return {
        data: [],
        suggestions: []
      };
    },
    async contentIdGetByModifiedId({
      commit
    }, payload) {
      let result = (await request("/content/getcontentidlistbymodifiedid", "POST", payload)) ?? {
        data: []
      };
      if (result?.data) {
        commit("contentUpdateModifiedListSet", result.data);
        return result;
      }
      return {
        data: []
      };
    },
    async contentGetExistingMarketPlaceList({
      commit
    }, payload) {
      //console.log("[contentGetExistingMarketPlaceList]");
      let result = (await request("/content/getcontentlist", "POST", payload)) ?? {
        data: [],
        suggestions: []
      };
      if (result) {
        commit("contentExistingMarketPlaceListSet", result.data);
      }
      return result;
    },
    async contentGetFromRainforest(_, payload) {
      let result = await request("/content/getcontentfromrainforest", "POST", payload);
      return result;
    },
    async contentUpdate({
      state
    }, {
      params,
      mixpanel_event_name
    }) {
      const item = state.list.find(el => el.content_id == params.content_id) || state.solo_items.find(el => el.content_id == params.content_id);
      let bullet_point_to_push = [ContentDisplayRulesMixin.methods.contentToDisplay(item, "bullet_point_1"), ContentDisplayRulesMixin.methods.contentToDisplay(item, "bullet_point_2"), ContentDisplayRulesMixin.methods.contentToDisplay(item, "bullet_point_3"), ContentDisplayRulesMixin.methods.contentToDisplay(item, "bullet_point_4"), ContentDisplayRulesMixin.methods.contentToDisplay(item, "bullet_point_5")];
      item.omny_version.bullet_point = bullet_point_to_push;
      let payload = {
        seller_id: item.seller_id,
        marketplace_id: item.marketplace_id,
        sku: item.sku,
        asin: item.asin,
        cvr_score: item.cvr_score,
        vendor_code: item.vendor_code,
        vendor_sku: item.vendor_sku,
        ean: item.ean,
        product_type: item.product_type,
        image_small: item.image_small,
        image_medium: item.image_medium,
        image_large: item.image_large,
        content_id: item.content_id,
        modified_attributes: item.modified_attributes,
        push_status: item.push_status,
        prev_push_status: item.prev_push_status,
        last_push_to_amazon_time: item?.last_push_to_amazon_time,
        sync_errors: item.sync_errors,
        omny_version: item.omny_version
      };
      const data = await request("/content/update", "POST", payload);
      if (mixpanel_event_name) {
        window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
          event_name: mixpanel_event_name,
          properties: {}
        });
      }
      return data;
    },
    async contentPush(_, {
      payload,
      mixpanel_event_name
    }) {
      const data = await request("/content/push", "POST", payload);
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: mixpanel_event_name,
        properties: {}
      });
      return data;
    },
    async contentDelete(_, payload) {
      const data = await request("/content/delete", "POST", payload);
      return data;
    },
    async contentGet(_, payload) {
      const data = await request("/content/get", "POST", payload);
      if (data) {
        return data;
      }
    },
    async contentGetTranslation(_, payload) {
      const data = await request("/content/asynctranslate", "POST", payload);
      if (data) {
        window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
          event_name: "userGeneratedAIListingTranslation",
          properties: {}
        });
        return data;
      }
    },
    async simpleTranslationGet(_, payload) {
      const data = await request("/content/simple_translate", "POST", payload);
      if (data) {
        return data?.translation;
      }
    },
    async contentGetSuggestedKeywords(_, payload) {
      const data = await request("/content/getsuggestedkeywords", "POST", payload);
      if (data) {
        return data;
      }
    },
    async contentApplySuggestedKeywords(_, {
      payload,
      mixpanel_event_name
    }) {
      const data = await request("/content/applysuggestedkeywords", "POST", payload);
      if (mixpanel_event_name) {
        window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
          event_name: mixpanel_event_name,
          properties: {}
        });
      }
      if (data) {
        return data;
      }
    },
    async contentScrapProductData(_, payload) {
      const data = await request("/content/scrapproductdata", "POST", payload);
      if (data) {
        return data;
      }
    },
    async contentGetParents({
      commit
    }, payload) {
      let childContentIds = [];
      let parentMarketplaces = [];
      let mappedParents = [];
      let parentsStringMap = [];
      let suggestions = [];
      let solo_items = [];
      let total = 0;
      const data = await request("/content/getparentasins", "POST", payload);
      if (data && data.parents) {
        suggestions = data.suggestions;
        const parents = data.parents;
        solo_items = parents.filter(el => !el.is_parent_asin);
        total = data.total;
        parentMarketplaces = Array.from(new Set(parents.map(el => el.marketplace_id)));
        mappedParents = parents.map(el => {
          const child_asins_array = el?.child_asins_structured_array ?? [];
          childContentIds = childContentIds.concat(child_asins_array.map(el => {
            return {
              asin: el.child_asin.replace(/^"|"$/g, ""),
              marketplace_id: el.marketplace_id.replace(/^"|"$/g, ""),
              seller_id: el.seller_id.replace(/^"|"$/g, "")
            };
          }));
          if (el.is_parent_asin) parentsStringMap.push([el.parent_asin, child_asins_array.map(el => ({
            ...el,
            asin: el.child_asin.replace(/^"|"$/g, "")
          }))]);
          return [el, {
            collapsed: true,
            asins: child_asins_array,
            processedAsin: []
          }];
        });
      }
      const parentsStringMapSet = new Map(parentsStringMap);
      return {
        childContentIds,
        mappedParents,
        total,
        parentMarketplaces,
        parentsStringMapSet,
        solo_items,
        suggestions
      };
    },
    async productValidate(_, payload) {
      const data = await request(`/product/content/validate`, "POST", payload);
      return data;
    },
    async productSmartListing(_, payload) {
      const data = await request(`/product/content/smart-listing`, "POST", payload);
      return data;
    },
    async categoryDefinition(_, payload) {
      let result = (await request("/content/smart_listing/category_definition", "POST", payload)) ?? {
        data: []
      };
      return result.data;
    },
    async productDataFromUrl(_, payload) {
      let result = (await request("/content/smart_listing/product_data_from_url", "POST", payload)) ?? {
        data: []
      };
      return result.data;
    },
    async competitorsList(_, payload) {
      const data = await request(`/product/content/competitors`, "POST", payload);
      //console.log(data);
      return data;
    },
    async productBenefits(_, payload) {
      const data = await request(`/product/content/benefits`, "POST", payload);
      return data;
    },
    async keywordBank(_, payload) {
      const data = await request(`/product/content/keywords`, "POST", payload);
      return data;
    },
    async imageList({
      commit
    }) {
      const data = await request("/product/images");
      if (data) {
        commit("imageListSet", data);
      }
      return data;
    },
    async imageUpload(_, payload) {
      const data = await request(`/product/images`, "POST", payload);
      return data;
    },
    async contentGetSoloItems({
      commit
    }, payload) {
      const data = (await request("/content/getsoloitems", "POST", payload)) ?? {
        data: []
      };
      return data;
    },
    async uploadBulkDataCSV({
      state
    }, payload) {
      const formData = new FormData();
      const blob = new Blob([payload.chunk], {
        type: "text/plain"
      });
      formData.append("file", blob);
      formData.append("file_name", payload.fileName);
      formData.append("file_type", payload.fileType);
      formData.append("total_chunks", payload.totalChunks);
      formData.append("chunk_index", payload.chunkIndex);
      try {
        const response = await request("/content/uploadcontentcsv", "POST", formData, false);
        //console.log("[instant response from server when clicked upload]");
        //const result = await response.json();
        //console.log(response.task_status);
        //console.log(response.task_id);

        if (!response.task_id) {
          throw new Error("Upload failed");
        }
        //console.log(
        //   `Chunk ${payload.chunkIndex + 1} of ${
        //     payload.totalChunks
        //   } uploaded successfully`,
        //   response
        // );
        return response;
      } catch (error) {
        console.error(`Error uploading chunk ${payload.chunkIndex + 1}`, error);
      }
      //return { status: response.status,task_id:response.task_id};
    },
    async contentCreateBulkGoogleSheet({
      state
    }, payload) {
      const formData = new FormData();
      const stringifyChunk = JSON.stringify(payload.chunk);
      const blob = new Blob([stringifyChunk], {
        type: "text/plain"
      });
      formData.append("data", blob);
      formData.append("sheet_name", payload.sheet_name);
      formData.append("sheet_type", payload.sheet_type);
      formData.append("task_type", payload.task_type);
      formData.append("workspace_id", payload.workspace_id);
      formData.append("account_id", payload.account_id);
      formData.append("total_chunks", payload.total_chunks);
      formData.append("chunk_index", payload.chunk_index);
      formData.append("total_pages", payload.total_pages);
      formData.append("page_index", payload.page_index);
      let result = await request("/content/generate_bulk_google_sheet", "POST", formData, false);
      if (result) {
        return result;
      }
    }
  }
};
export default content;